var styles = {"pageLink":"PageLink-module_pageLink__eGdn4","active":"PageLink-module_active__v-zZH","textWrapper":"PageLink-module_textWrapper__yoV0G","imageContainer":"PageLink-module_imageContainer__0rNct","disabled":"PageLink-module_disabled__XXl9D","imageWrapper":"PageLink-module_imageWrapper__-I9a-"};

export { styles as default };
//# sourceMappingURL=PageLink.module.scss.js.map
